import { Unity, useUnityContext } from "react-unity-webgl";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import heartDecor from "../../../assets/images/coin-store-figma/decor-heart.svg";
import "./GameDetail.css";

export default function EmojiPlay() {
    const navigate = useNavigate();
    const { unityProvider } = useUnityContext({
        loaderUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/EmojiPlay/WebGlEmojiGame.loader.js`,
        dataUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/EmojiPlay/WebGlEmojiGame.data`,
        frameworkUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/EmojiPlay/WebGlEmojiGame.framework.js`,
        codeUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/EmojiPlay/WebGlEmojiGame.wasm`,
    });

    return (
        <section className="game-detail-page">
            <img src={heartDecor} alt="" className="game-detail-heart" aria-hidden="true" />
            <div className="game-detail-hero">
                <Container className="game-detail-hero-inner">
                    <button className="game-detail-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                        <FaArrowLeftLong />
                    </button>
                    <h1 className="game-detail-title">Emoji Play</h1>
                </Container>
            </div>
            <div className="game-detail-main py-sm-5 py-4">
                <Container className="game-detail-container">
                    <div className="game-detail-frame game-detail-frame-emoji">
                        <Unity unityProvider={unityProvider} className="game-detail-unity game-detail-unity-emoji" />
                    </div>
                </Container>
            </div>
        </section>
    );
}
